export const WS_CONNECTED_ELSEWHERE: string = 'WS_CONNECTED_ELSEWHERE';
export const WS_UPDATE_PEER_STATUS: string = 'WS_UPDATE_PEER_STATUS';
export const WS_WAITING_FOR_PEER: string = 'WS_WAITING_FOR_PEER';
export const WS_CURRENT_STATE: string = 'WS_CURRENT_STATE';
export const WS_DISCONNECTED: string = 'WS_DISCONNECTED';
export const WS_CONNECTED: string = 'WS_CONNECTED';
export const WS_LANGUAGE: string = 'WS_LANGUAGE';
export const WS_STDOUT: string = 'WS_STDOUT';
export const WS_STDERR: string = 'WS_STDERR';
export const WS_RESULT: string = 'WS_RESULT';
export const WS_CLEAR: string = 'WS_CLEAR';
export const WS_PONG: string = 'WS_PONG';
export const WS_END: string = 'WS_END';


export const WS_SEND_UPDATE_STATUS: string = 'updateStatus';
export const WS_SEND_END_INTERVIEW: string = 'end';
export const WS_SEND_SWAP_ROLE: string = 'swap';
export const WS_SEND_LANGUAGE: string = 'language';
export const WS_SEND_PING: string = 'ping';
export const WS_SEND_ACK: string = 'ack';
export const WS_SEND_RUN: string = 'run';
